import { useMemo } from 'react';
import { useAuth } from 'lib/context';
import {
  checkIfQuickVideoAvatarEnabledForUser,
  checkIfQuickVideoAvatarEnabledForCustomer,
  checkIfAISpotlightEnabledForUser,
  checkIfAISpotlightEnabledForCustomer,
  checkIfQuickVideosEnabled,
  checkIfSuggestedContentEnabled,
  checkIfVinReelsEnabled,
} from './utils';

export const useAIFeatureFlags = () => {
  const { userData } = useAuth();
  return useMemo(() => {
    return {
      isQuickVideoAvatarEnabledForUser:
        checkIfQuickVideoAvatarEnabledForUser(userData),
      isQuickVideoAvatarEnabledForCustomer:
        checkIfQuickVideoAvatarEnabledForCustomer(userData),
      isVinReelsEnabled: checkIfVinReelsEnabled(userData),
      isAISpotlightEnabledForUser: checkIfAISpotlightEnabledForUser(userData),
      isAISpotlightEnabledForCustomer:
        checkIfAISpotlightEnabledForCustomer(userData),
      isQuickVideosEnabled: checkIfQuickVideosEnabled(userData),
      isSuggestedContentEnabled: checkIfSuggestedContentEnabled(userData),
    };
  }, [userData]);
};
